module.exports = __webpack_public_path__ + "static/media/download-cxm-app1.4c3e9f40.png";